<ion-fab slot="fixed" vertical="bottom" horizontal="end">
  <ion-fab-button class="primary-fab-btn" (click)="handleTranslationAction()">
    <ion-icon name="globe" class="white-icon-color"></ion-icon>
  </ion-fab-button>
  <ion-fab-list side="top">
    <ion-fab-button
      [attr.data-desc]="'translation.change_currency' | translate"
      (click)="presentCurrencyModal()"
      *ngIf="currency"
      class="white-fab-btn"
    >
      <ion-text data-desc="Change Currency">{{ selectedCurrency }}</ion-text>
    </ion-fab-button>
    <ion-fab-button
      [attr.data-desc]="'translation.change_language' | translate"
      (click)="presentLanguageModal()"
      *ngIf="language"
      class="white-fab-btn"
    >
      <ion-text data-desc="Change Language">{{ selectedLanguage }}</ion-text>
    </ion-fab-button>
  </ion-fab-list>
</ion-fab>
